import { createSelector, Selector } from '@reduxjs/toolkit';
import {
  ILessonsCatalog,
  ICoursesCatalog,
  tCatalogItems,
  tSkills,
  tCatalogStatus
} from 'common/modules/ReactShared';
import { selectShared } from '../sharedSelectors';
import { tSharedAppState, tSharedStore } from '../types';

const selectCatalogStore: Selector<tSharedAppState, tSharedStore['catalog']> =
  createSelector([selectShared], (state) => state.catalog);

const selectLessonsCatalog: Selector<tSharedAppState, ILessonsCatalog | null> =
  createSelector([selectCatalogStore], (catalogStore) => catalogStore.lessonsCatalog);

const selectCoursesCatalog: Selector<tSharedAppState, ICoursesCatalog | null> =
  createSelector([selectCatalogStore], (catalogStore) => catalogStore.coursesCatalog);

const selectCatalogItems: Selector<tSharedAppState, tCatalogItems> = createSelector(
  [selectCatalogStore],
  (catalogStore) => catalogStore.catalogItems
);

const selectCatalog: Selector<
  tSharedAppState,
  {
    lessonsCatalog: ILessonsCatalog | null;
    coursesCatalog: ICoursesCatalog | null;
    catalogItems: tCatalogItems;
  }
> = createSelector(
  [selectLessonsCatalog, selectCoursesCatalog, selectCatalogItems],
  (lessonsCatalog, coursesCatalog, catalogItems) => ({
    lessonsCatalog,
    coursesCatalog,
    catalogItems
  })
);

const selectSkills: Selector<tSharedAppState, tSkills | null> = createSelector(
  [selectCatalogStore],
  (catalogStore) => catalogStore.skills
);

const selectCatalogStatus: Selector<tSharedAppState, tCatalogStatus> = createSelector(
  [selectCatalogStore],
  (catalogStore) => catalogStore.status
);

const courseSelectors = {
  selectCatalogStore,
  selectLessonsCatalog,
  selectCoursesCatalog,
  selectCatalogItems,
  selectCatalog,
  selectSkills,
  selectCatalogStatus
};

export default courseSelectors;
